export const stripeKeys = {
  // publishableKey: 'pk_test_Mwserc4flE4ZvoTE3XmAxXEh0087xmPgYI',
  publishableKey: 'pk_live_BMizRHWHVFgOBxNN5geMvzpz00AhcHD65g'
};
